import { useEffect } from 'react';

// Transition de toast SANS animation CSS (constat APK 15/07) : certaines
// WebView Android gèlent les animations CSS (renderer throttlé après un
// retour d'arrière-plan). Or react-toastify fait TOUT reposer dessus :
// l'entrée (bounceInDown — gelée à sa 1re frame = toast invisible hors
// écran), la fermeture auto (animationend de la barre de progression) et
// le repli de l'emplacement (requestAnimationFrame). Résultat observé en
// boutique : le message n'apparaissait qu'au réveil du renderer, en pleine
// transition de page.
//
// Ici : l'affichage est immédiat (aucune classe d'animation posée) et la
// sortie appelle done() via un vrai setTimeout — le pipeline ne dépend
// plus du moteur d'animations. La fermeture auto JS est branchée dans
// App.js (toast.onChange → toast.dismiss), même raison.
const ToastSansAnimation = ({ isIn, done, children }) => {
  useEffect(() => {
    if (!isIn) {
      const t = setTimeout(done, 40);
      return () => clearTimeout(t);
    }
    return undefined;
  }, [isIn, done]);
  return children;
};

export default ToastSansAnimation;
